import { LOCATION_CHANGE } from 'connected-react-router';
import qs from 'qs';

const DEFAULT_STATE = {
  applicationId: '',
};

export function candidateProfile(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const { search } = action.payload.location;
      const { applicationId } = qs.parse(search, { ignoreQueryPrefix: true });

      return {
        ...state,
        applicationId: applicationId || '',
      };
    }
    default:
      return state;
  }
}
